export class ClickLog {
  public ClickLogId: number = 0;
  public MessageId: number = 0;
  public CommunicationId: number = 0;
  public SentId: number = 0;
  public ProfileId: number = 0;
  public Url: string = '';
  public Clicked: boolean = false;
  public FirstClick: Date = new Date();
  public LastClick: Date = new Date();
  public TotalClicks: number = 0;
  public SendTo: string = '';
  public SendToDisplayName: string = '';
}
